import { render, staticRenderFns } from "./SetupTagPanel.vue?vue&type=template&id=79e0eca8&scoped=true"
import script from "./SetupTagPanel.vue?vue&type=script&lang=js"
export * from "./SetupTagPanel.vue?vue&type=script&lang=js"
import style0 from "./SetupTagPanel.vue?vue&type=style&index=0&id=79e0eca8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0eca8",
  null
  
)

export default component.exports